import { getAllDocuments } from '@modusign/openapi-client-document';
import { all, call, put, select, takeEvery } from 'redux-saga/effects';

import workspaceService from '@app/libs/workspaceService';
import { CONTRACT_SETUP_SUBMITTED } from '@app/store/actionTypes';
import {
  fetchSigningRequestCount,
  fetchSigningRequestCountFailure,
  fetchSigningRequestCountSuccess,
} from '@app/store/softLanding/actions';
import { getSoftLandingCountOfDocuments } from '@app/store/softLanding/selectors';

export function* handleFirstSigningRequest() {
  const currentCountOfDocuments: ReturnType<typeof getSoftLandingCountOfDocuments> = yield select(
    getSoftLandingCountOfDocuments
  );
  if (currentCountOfDocuments === 0) {
    yield put(fetchSigningRequestCount());
    try {
      const { countOfDocuments } = yield call(getAllDocuments, workspaceService.getWorkspaceId(), {
        // TODO(org3): 서명요청시 기본 필터 조건을 정책 반영
        // assigned: hasOrganization ? true : undefined,
        assigned: undefined,
        limit: 1,
        offset: 0,
      });
      yield put(fetchSigningRequestCountSuccess(countOfDocuments));
    } catch (error) {
      yield put(fetchSigningRequestCountFailure(error));
    }
  }
}

export default function* sagas() {
  yield all([takeEvery(CONTRACT_SETUP_SUBMITTED, handleFirstSigningRequest)]);
}
